import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../../api/services';

export const fetchChannelDetails: any = createAsyncThunk('channelDetails/fetChchannelDetails', async (payload) => {
    const response = await API.post(`/get-channel-details`, payload);
    return response?.data;
});

interface channelDetail {
    singleChannelDetails: Record<any, any>
    isInquirySent: any
    
}

const initialState: channelDetail = {
    singleChannelDetails: {},
    isInquirySent: null
};

const getSingleChannelDetails = createSlice({
    name: 'channel-details',
    initialState,
    reducers: {
        setChannelDetailsState: (state, { payload }) => {
            state.singleChannelDetails = payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchChannelDetails.fulfilled, (state, action) => {
                state.singleChannelDetails = action.payload;
                state.isInquirySent = action.payload?.data?.is_inquiry_sent ?? null;
            })
            .addCase(fetchChannelDetails.rejected, (state, action) => {
                console.error('Failed to fetch channel details:', action.error);
            });
    }
});
export const { setChannelDetailsState } = getSingleChannelDetails.actions;
export default getSingleChannelDetails.reducer;